import actions from "./actions"
import state from "./state"
import mutations from "./mutations"
export default {
	state: state,
	actions: actions,
	mutations: mutations
}